import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import ReactPixel from 'react-facebook-pixel';
import './index.css';

import App from './App';

ReactGA.initialize('G-HTM9BK0CRF');

// Meta Pixel
ReactPixel.init('879992535157466');
ReactPixel.pageView();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker so Android can treat this as an installable web app
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then(() => console.log('Service worker registered'))
      .catch((error) =>
        console.error('Service worker registration failed:', error)
      );
  });
}